export default {
  title: "SORU7",
  text: `Bir sanatçıya, gazetecilerle yaptığı sohbet sırasında gazetecinin biri "Efendim, uzun süredir yeni bir eser vermiyorsunuz. Yoksa düşüncelerinizin üzerine kar mı yağdı?" diye sordu. Bunun üzerine sanatçı “Kışın yağan kar, toprağı örterek bitkileri şiddetli soğuktan korur. Toprağın altındaki bitki ve hayvanlar ilkbahara hazırlanır. Karlar eridiğinde tüm canlılıklarıyla hayatlarına devam eder. Evet, benim düşüncelerimin üzerine kar yağdı." şeklinde cevap verdi.`
};



// WEBPACK FOOTER //
// ./src/assets/goz-ritim/lgs/7.js